import styled, { StyledProps } from 'styled-components'
import { IButtonProps } from '../../Button/types'

const Action = styled.div<StyledProps<IButtonProps>>``

const Control = styled.div`
  flex-grow: 1;
`

const Block = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`

export default { Block, Control, Action }
